import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { config } from "../../shared/environment";

export type staffReportResponse = {
    staffReport: {
        count: number,
        rows: {
            staffId: number,
            staffName: string,
            staffRole: string,
            createdDate: string,
            work: {
                workDate: string,
                totalWorkingTime: string
            }[],
            order: {
                orderDate: string,
                ordersCount: number,
                discounts: number,
                totalSales: number,
                netSales: number
            }[]
        }[]
    }
    statusCode: string;
    message: string;
    success: boolean;
};

export type staffReportData = {
    staffId: number,
    staffName: string,
    staffRole: string,
    createdDate: string,
    work: {
        workDate: string,
        totalWorkingTime: string
    }[],
    order: {
        orderDate: string,
        ordersCount: number,
        discounts: number,
        totalSales: number,
        netSales: number
    }[]
}


interface intstate {
    // getAllStaffReport: { loading: boolean, offset: number, value: staffReportResponse | null, error: string, isReached: boolean },
    staffDataValue: { value: staffReportData[], count: number, loading: boolean, error: string | null, from: string | null, to: string | null }
}

const initialState: intstate =
{
    // getAllStaffReport: { loading: false, offset: 0, value: null, error: '', isReached: false },
    staffDataValue: { value: [], count: 0, loading: false, error: null, from: null, to: null }
}

// const [from, setFrom] = useState<string | null>(null)
// const [to, setTo] = useState<string | null>(null)
export const getAllStaffReport = createAsyncThunk('staffReport/getAll', ({ data }: { data: { limit: number, offset: number, filterData: string } }) => {
    // const parseFilter = data?.filterData ? JSON.parse(data?.filterData) : null
    // setFrom(parseFilter?.customDateRange?.begin)
    // setTo(parseFilter?.customDateRange?.end)
    let Url = HttpRoutingService.replaceUrl(API.staffReport, { storeId: config.storeId })
    return HttpRoutingService.getMethod<staffReportResponse>(Url, data)
})

const staffReportSlice = createSlice({
    initialState,
    name: "staffReport",
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(getAllStaffReport.pending, (state, action) => {
                state.staffDataValue.loading = true
            })
            .addCase(getAllStaffReport.fulfilled, (state, action) => {
                const offset = action.meta.arg.data.offset || 0
                const rows = action.payload.staffReport.rows || []
                if (offset > 0) {
                    state.staffDataValue.value = [...state.staffDataValue.value, ...rows]
                } else {
                    state.staffDataValue.value = rows
                }
                state.staffDataValue.count = action.payload.staffReport.count || 0;
                state.staffDataValue.loading = false;
                const parseFilter = action?.meta?.arg?.data?.filterData ? JSON.parse(action?.meta?.arg?.data?.filterData) : null
                state.staffDataValue.from = parseFilter?.customDateRange?.begin
                state.staffDataValue.to = parseFilter?.customDateRange?.end

            })
            .addCase(getAllStaffReport.rejected, (state, action) => {
                state.staffDataValue.loading = false
                state.staffDataValue.error = action.error.message as string
            })
    }
})

export default staffReportSlice?.reducer
